export const EOrderType = {
  Open: 0,

  Finished: 1,

  Canceled: 2,
} as const

export type EOrderType = (typeof EOrderType)[keyof typeof EOrderType]
